import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Button, Form, Input, Space } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
const MultiTextTableFilter = (props) => {
    const [form] = Form.useForm();
    const applyFilterClicked = (values) => {
        // console.log("XXX apply filter", values);
        props.applyFilterKeys(values);
    };
    const clearFilterClicked = () => {
        props.clearFilterKeys(props.inputs.map(input => input.fetchKey));
        const blankInputs = props.inputs.map(it => {
            return {
                [it.fetchKey]: null
            };
        });
        form.setFieldsValue(blankInputs);
    };
    return (_jsxs("div", { className: "custom-filter-dropdown", children: [_jsx(Form, { layout: "vertical", form: form, onFinish: applyFilterClicked, initialValues: props.filters, children: props.inputs.map((input, index) => (_jsx(Form.Item, { name: input.fetchKey, style: { marginBottom: 5 }, label: (props.showInputLabels ? input.name : null), children: _jsx(Input, { placeholder: input.name, style: { width: "100%" } }) }, index))) }), _jsxs(Space, { className: "pt-20", children: [_jsxs(Button, { type: "primary", onClick: form.submit, children: [_jsx(SearchOutlined, {}), " Apply"] }), _jsxs(Button, { type: "default", onClick: clearFilterClicked, children: [_jsx(CloseOutlined, {}), " Clear"] })] })] }));
};
const multiTextTableFilter = (inputs, showInputLabels = true) => {
    const MultiTextTableFilterBuilder = (col, filters, openFilterKey, setOpenFilterKey, applyFilterKeys, clearFilterKeys) => {
        const filter = col.filter;
        return {
            ...col,
            key: `unused-${filter.requestKey}`,
            filterMultiple: false,
            filteredValue: inputs.map(it => it.fetchKey).filter(it => filters[it]) ?? null, // filters[freightQtyEqualOrGreaterThanRequestKey] || filters[freightQtyEqualOrLessThanRequestKey] || filters[freightUnitOfMeasureRequestKey],
            filterDropdownProps: {
                open: openFilterKey === filter.requestKey,
                onOpenChange: (visible) => {
                    setOpenFilterKey(visible ? filter.requestKey : undefined);
                }
            },
            filterDropdown: (_jsx(MultiTextTableFilter, { inputs: inputs, filters: filters, applyFilterKeys: applyFilterKeys, clearFilterKeys: clearFilterKeys, showInputLabels: showInputLabels }))
        };
    };
    return MultiTextTableFilterBuilder;
};
export default multiTextTableFilter;
